import { DataColumn } from '@shared/models';

export function updateFrozenColumnOffsets<T extends DataColumn>(
  columns: T[],
  startOffset: number = 0,
  frozenColumnClass = 'p-datatable-frozen-column'
): T[] {
  let offset = startOffset;
  columns = columns.map((column) => {
    if (!column.class?.includes(frozenColumnClass)) {
      return column;
    }

    const left = `${offset}rem`;
    const nextOffset = getColumnWidthInRem(column.width);

    offset += nextOffset;

    return {
      ...column,
      left,
    };
  });

  return columns;
}

export function getColumnWidthInRem(width: string): number {
  if (!width) {
    return 0;
  }

  const remMatch = /([\d.]+)rem/.exec(width);
  if (remMatch) {
    return Number(remMatch[1]);
  }

  const pxMatch = /([\d.]+)px/.exec(width);
  if (pxMatch) {
    return Number(pxMatch[1]) / 16;
  }

  return 0;
}

export function getColumnKey(col: DataColumn | undefined): string | undefined {
  return col?.id ?? col?.field;
}
